<template>
    <div class="loadable | flex-1 flex flex-col w-full" :class="{ 'loading': loading }">
        <div class="sticky top-0 z-20 flex items-center w-full shadow-lg bg-gray-100 bg-opacity-80 backdrop-mix-oversaturate-lg-blur-md px-4" v-if="hasHeader">
            <div class="inline-flex justify-center items-center p-4" v-if="selectable">
                <input
                    :checked="allSelected"
                    class="form-checkbox"
                    :disabled="!rows.length"
                    type="checkbox"
                    @change="onChangeSelectAll"
                >
            </div>
            <nio-table-heading
                v-bind="column"
                class=""
                :sort="sort"
                :sortable="column.sortable || false"
                :key="column.name"
                @sort="$emit('sort', $event)"
                v-for="column in columns"
            >
                <nio-icon class="text-base" :name="column.icon" v-if="column.icon" />
                <span v-text="column.label" v-if="column.label" />
            </nio-table-heading>
        </div>
        <div class="flex-grow flex flex-col justify-center items-center text-gray-600" v-if="!rows.length">
            <slot name="no-results" />
        </div>
        <div
            class="flex items-center justify-between w-full bg-white | hover:bg-gray-100 hover:text-gray-800 | group transition-color duration-200 px-4"
            :key="row.id"
            v-for="(row, rowIndex) in rows"
        >
            <div class="inline-flex justify-center items-center p-4" v-if="selectable">
                <input
                    :checked="selections.includes(row.id)"
                    class="form-checkbox"
                    type="checkbox"
                    @change="onSelectChange($event, row)"
                >
            </div>
            <nio-table-cell
                v-bind="column"
                :key="column.name"
                v-for="column in columns"
            >
                <slot
                    :column="column"
                    :index="rowIndex"
                    :name="`column-${column.name}`"
                    :row="row"
                >
                    {{ row[column.name] }}
                </slot>
            </nio-table-cell>
        </div>
    </div>
</template>

<script>
    import NioTableHeading from './NioTableHeading.vue';
    import NioTableCell from './NioTableCell.vue';

    export default {
        components: {
            NioTableHeading,
            NioTableCell,
        },

        props: {
            columns: {
                type: Array,
                required: true,
            },
            rows: {
                type: Array,
                required: true,
            },
            sort: {
                type: String,
                default: '',
            },
            selections: {
                type: Array,
                default: null,
            },
            loading: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            selectable() {
                return !!this.selections;
            },

            allSelected() {
                return this.selectable && this.rows.length && this.selections.length == this.rows.length;
            },

            hasHeader() {
                return this.columns.some(column => {
                    return column.label || column.icon;
                });
            },
        },

        methods: {
            onChangeSelectAll(event) {
                if (event.target.checked) {
                    this.$emit('update:selections', this.rows.map(row => row.id));
                } else {
                    this.$emit('update:selections', []);
                }
            },

            onSelectChange(event, row) {
                const selections = [...this.selections];

                if (!event.target.checked && selections.includes(row.id)) {
                    selections.splice(selections.indexOf(row.id), 1);
                } else {
                    selections.push(row.id);
                }

                this.$emit('update:selections', selections);
            },
        },
    };
</script>
